/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-data': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 5h1.25v5H17.5V5zm-3.125-1.875h1.25V10h-1.25V3.125zM11.25 6.25h1.25V10h-1.25V6.25zM10 18.75H8.75V15a1.877 1.877 0 00-1.875-1.875h-2.5A1.877 1.877 0 002.5 15v3.75H1.25V15a3.129 3.129 0 013.125-3.125h2.5A3.129 3.129 0 0110 15v3.75zM5.625 5.625a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z"/>'
  }
})
